import React, {useCallback, useEffect, useState} from 'react';
import {Form} from 'react-bootstrap';
import {useSelector, useDispatch} from 'react-redux';
import {
  changeActiveFilters,
  addFilteredCategory,
  removeFilteredCategory,
  setFilterCount,
} from '../../redux/Filters';

function FilterItem({
  sub_filter_text,
  field,
  header,
  categoryId,
  trans_lang_variable_value,
  trans_key,
  onToggleFilter,
}) {
  const [isChecked, setIsChecked] = useState(false);
  const activeFilters = useSelector(state => state.showFilters.activeFilters);
  const dispatch = useDispatch();

  const hasCategory = useCallback(() => {
    let ret = false;
    activeFilters.forEach(filter => {
      if (filter.id === categoryId) {
        ret = true;
      }
    });
    return ret;
  }, [activeFilters, categoryId]);

  const setCheckBoxes = useCallback(() => {
    let checkedBox = false;
    if (hasCategory()) {
      activeFilters.forEach(filter => {
        if (filter.id === categoryId) {
          filter.filteredCategories.forEach(filteredCategory => {
            if (filteredCategory.trans_lang_variable_value === trans_lang_variable_value) {
              checkedBox = true;
            }
          });
        }
      });
    }
    setIsChecked(checkedBox);
  }, [activeFilters, categoryId, trans_lang_variable_value, hasCategory]);

  useEffect(() => {
    setCheckBoxes();
  
  }, [setCheckBoxes]);

  const displayText = sub_filter_text
    .replace('(18-25)', '(18-24)')
    .replace('(26-41)', '(25-40)')
    .replace('(42-57)', '(41-56)')
    .replace('(58+)', '(57+)');

    const boxChanged = () => {

    const filterCategory = {
      text: sub_filter_text,
      trans_key: trans_key,
      trans_lang_variable_value: trans_lang_variable_value || sub_filter_text.toLowerCase(),
    };

    const filter = {
      id: categoryId,
      field: field,
      title: header,
      filteredCategories: [filterCategory],
    };

    if (hasCategory() && !isChecked) {
      dispatch(addFilteredCategory(filter));
      setIsChecked(true);
    } else if (!hasCategory() && !isChecked) {
      dispatch(changeActiveFilters([...activeFilters, filter]));
      setIsChecked(true);
    } else {
      dispatch(removeFilteredCategory({id: categoryId, filteredCategory: sub_filter_text}));
      setIsChecked(false);
    }
    dispatch(setFilterCount(categoryId));

    onToggleFilter(categoryId, trans_key, trans_lang_variable_value, isChecked);
  };

  return (
    <Form.Group controlId={`category-${sub_filter_text}`}>
      <Form.Check checked={isChecked} onChange={boxChanged} type="checkbox" label={displayText} />
    </Form.Group>
  );
}

export default FilterItem;
